import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { effect, Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SearchProductModeSwitcherService {
  readonly searchProductClass = 'show-search-product';
  readonly showSearchProduct = signal(false);

  private renderer: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);

    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        this.applySearchProductClass();
      });
    }
  }

  changeMode(isShow: boolean): void {
    this.showSearchProduct.set(isShow);
  }

  private applySearchProductClass(): void {
    this.renderer[this.showSearchProduct() ? 'addClass' : 'removeClass'](this.document.body, this.searchProductClass);
  }
}
